import React from 'react';
import pure from 'recompose/pure';

class Polyline extends React.Component {
    static defaultProps = {
        strokeOpacity: 1,
        strokeWeight: 3,
        zIndex: 1
    };
    constructor(props) {
        super(props);
        const polyline = new google.maps.Polyline({
            path: props.path || [],
            strokeColor: props.color,
            strokeOpacity: props.strokeOpacity,
            strokeWeight: props.strokeWeight,
            geodesic: props.geodesic,
            icons: props.icons,
            zIndex: props.zIndex
        });
        this.state = {
            polyline
        };
    }

    UNSAFE_componentWillMount = () => {
        this.state.polyline.setMap(this.props.mapHelper.map);
        this.addEventListener();
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.state.polyline.setOptions(nextProps);
    }

    componentWillUnmount = () => {
        this.state.polyline.setMap(null);
        this.removeListeners();
    };

    addEventListener = () => {
        this.mouseMoveListener =
            this.props.onMouseMove &&
            google.maps.event.addListener(
                this.state.polyline,
                'mousemove',
                event => {
                    this.props.onMouseMove && this.props.onMouseMove(event);
                }
            );

        this.mouseOverListener =
            this.props.onMouseOver &&
            google.maps.event.addListener(
                this.state.polyline,
                'mouseover',
                event => {
                    this.props.onMouseOver && this.props.onMouseOver(event);
                }
            );

        this.mouseOutListener =
            this.props.onMouseOut &&
            google.maps.event.addListener(
                this.state.polyline,
                'mouseout',
                event => {
                    this.props.onMouseOut && this.props.onMouseOut(event);
                }
            );
    };

    removeListeners = () => {
        google.maps.event.removeListener(this.mouseMoveListener);
        google.maps.event.removeListener(this.mouseOverListener);
        google.maps.event.removeListener(this.mouseOutListener);
    };

    render() {
        return null;
    }
}
const PurePolyline = pure(Polyline);
export { PurePolyline as Polyline };
